import type React from 'react';

import { PageBody } from '../components/PageBody';
import { PageHeading } from '../components/PageHeading';
import { PageTabs } from '../components/PageTabs';

import { useTrackPageView } from './hooks/useTrackPageView';

export const Layout: React.FC = () => {
	useTrackPageView();

	return (
		<div className="container pb-4">
			<PageHeading />
			<PageTabs />
			<PageBody />
		</div>
	);
};
